var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationBad({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.90098 21.8497H22.1081C23.521 21.8497 24.4307 20.3593 23.792 19.1012L13.6885 1.19739C12.9915 -0.196006 10.998 -0.196006 10.3012 1.19739L0.197696 19.1012C-0.421679 20.3593 0.488028 21.8497 1.90098 21.8497ZM13.5919 17.6882C13.5919 18.6173 12.9144 19.3335 11.9467 19.3335C10.9789 19.3335 10.3014 18.6173 10.3014 17.6882V17.6495C10.3014 16.7205 10.9789 16.0043 11.9467 16.0043C12.9144 16.0043 13.5919 16.7205 13.5919 17.6495V17.6882ZM11.0561 5.59108H12.9531C13.4755 5.59108 13.7854 6.03626 13.7274 6.59757L12.8949 13.8752C12.8368 14.3978 12.4884 14.7269 12.0045 14.7269C11.5206 14.7269 11.1722 14.3978 11.1142 13.8752L10.2817 6.59757C10.2238 6.03626 10.5337 5.59108 11.0561 5.59108Z",
    fill: "#E00606"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBad);
export default __webpack_public_path__ + "static/media/notificationBad.13660fe193fad7a3c2e3ddbb5724da6d.svg";
export { ForwardRef as ReactComponent };